// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"nl_a bfq_a bfq_x","FilterForm__vgroup":"nl_b bfq_ro"};